import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import AppContainer from './modules/app';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
);
